import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonUIComponent } from '../../atoms/button/button.component';
import { IconUIComponent } from '../../atoms/icon/icon.component';

/** i18n keys of the cabinet's copy; the title gets its `!` from the template. */
export interface RegistrationSuccessDialogData {
  title: string;
  text: string;
  buttonText: string;
  testId: string;
}

@Component({
  selector: 'fr8bot-ui-registration-success-dialog',
  templateUrl: './registration-success-dialog.component.html',
  imports: [TranslatePipe, IconUIComponent, ButtonUIComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegistrationSuccessDialogComponent {
  protected readonly data = inject<RegistrationSuccessDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef =
    inject<MatDialogRef<RegistrationSuccessDialogComponent>>(MatDialogRef);

  /** Closed by the user, as opposed to a navigation or a logout, which close it with no result. */
  protected closeDialog(): void {
    this.dialogRef.close(true);
  }
}
